import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { inject, observer } from 'mobx-react';
import { action, observable } from 'mobx';
import styled from 'styled-components';
import { BlockColorEnum } from '../../../../enum/block-color.enum';
import { ClearCheckMarkIcon } from '../../../icons';
import { IInjectedProps } from '../../../../interface/component/injected-props.interface';
import { ColorEnum } from '../../../../enum/color.enum';

const Input = styled.input`
  z-index: -1;
  position: absolute;
  height: 0px;
  width: 0px;
  margin: 0 17px 0 0;
`;

const CheckableButtonContainer = styled.div`
  display:flex;
  flex-direction: row;
  align-items: center;
`;
const InputContainer = styled.div`
  display: flex;
  position: relative;
  align-items: center;
`;

const TextContainer = styled.div`
  word-wrap: break-word;
  font-size: 16px;
  ${(props: { clickable: boolean }) => props.clickable ? `cursor: help;
  &:hover {
    text-decoration: underline;
  }` : ''}
`;

const RadioButton = styled.div`
  display: flex;
  margin-left: 3px;
  margin-right: 14px;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  justify-items: center;
  border-radius: 50%;
  border: 2px solid ${(props: { focused: boolean, isInvalid: boolean }) => props.focused ? BlockColorEnum.PrimaryButtonColor(props) : (props.isInvalid ? BlockColorEnum.ErrorColor(props) : BlockColorEnum.InactiveColor(props))};
`;

const RadioButtonSelection = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${BlockColorEnum.PrimaryButtonColor};
`;

interface ICheckboxWrapperProps {
  selected: boolean;
  focused: boolean;
  isInvalid: boolean;
}

const CheckboxWrapper = styled.div`
  width: 25px;
  height: 25px;
  margin-right: 12px;
  border-radius: 3px;
  border: 1px solid ${(props: ICheckboxWrapperProps) => props.focused ? BlockColorEnum.PrimaryButtonColor(props) : (props.isInvalid ? BlockColorEnum.ErrorColor(props) : BlockColorEnum.InactiveColor(props))};
  background: ${(props: ICheckboxWrapperProps) => props.selected ? BlockColorEnum.PrimaryButtonColor(props) : ColorEnum.Transparent(props)};
`;

interface IFormFieldSelectableProps {
  type: 'radio' | 'checkbox';
  name: string;
  onChange: () => void;
  onTextClicked?: (value: any) => void;
  value: boolean;
  label: string;
  disabled: boolean;
  onClick: () => void;
  onBlur: () => void;
  isInvalid: boolean;
}

@inject('state')
@observer
export class FormFieldSelectable extends React.Component<IFormFieldSelectableProps & IInjectedProps> {
  @observable focused: boolean = false;
  input;

  @action
  onFocus = () => {
    this.focused = true;
  }

  @action
  onBlur = () => {
    this.focused = false;
    if (this.props.onBlur) {
      this.props.onBlur();
    }
  }

  onChange = () => {
    ReactDOM.findDOMNode(this.input).focus();
    this.props.onChange();
  }

  render() {
    const props = this.props;
    return <CheckableButtonContainer>
      <InputContainer>
        <Input
          ref={(input) => this.input = input}
          name={props.name}
          id={props.name}
          type={props.type}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onChange={!props.disabled && this.onChange}
          checked={props.value}
        />
        {props.type === 'radio' ? <RadioButton
          focused={this.focused}
          onClick={!props.disabled && this.onChange}
          onBlur={props.onBlur}
          isInvalid={props.isInvalid}
        >
          {props.value ? <RadioButtonSelection/> : null}
        </RadioButton> : <CheckboxWrapper
          focused={this.focused}
          selected={props.value}
          onClick={!props.disabled && this.onChange}
          onBlur={props.onBlur}
          isInvalid={props.isInvalid}
        >
          {props.value ? <ClearCheckMarkIcon color={this.props.state.colors.White}/> : null}
        </CheckboxWrapper>}
      </InputContainer>
      <TextContainer
        clickable={Boolean(props.onTextClicked)}
        onClick={
          !props.disabled && props.onClick
        }
      >
        {props.label}
      </TextContainer>
    </CheckableButtonContainer>;
  }
}
